<template>
  <div>
<!--    <el-button  :icon="iconName" @click="toggleMenuOpen"></el-button>-->
    <img v-if="isNavMenuOpen" src="../assets/img/menu-open.png" class="no-b" @click="toggleMenuOpen" />
    <img v-else="isNavMenuOpen" src="../assets/img/menu-close.png" class="no-b" @click="toggleMenuOpen" />
      <span @click="toPanel" class="panelStyle" >系统看板</span>
    <!-- <el-tag class="v3-tag" v-for="(tag, index) in tags" :key="tag.index" closable
    @close="closeTag(index)" :type="tag.tabType"
    @click="activeTag(tag.index)">
      {{tag.title}}
    </el-tag> -->
  </div>
</template>

<script>
  import debug from 'debug'
  import { mapState } from 'vuex'

  const log = debug('v3:TopNav')

  export default {
    name: 'TopNav',
    data() {
      return {
        // tags: []
      }
    },
    watch: {
      '$route' (to, from) {
        log('to', to)
        log('from', from)

        this.addCachedView(to)
      }
    },
    computed: {
      ...mapState(['isNavMenuOpen']),
      iconName() {
          return this.isNavMenuOpen ? 'fa fa-outdent' : 'fa fa-indent'
      },
      tags () {
        return this.$store.state.navTags.map((item) => {
          return {
            index: item.index,
            title: item.title,
            tabType: item.active ? 'success' : 'info',
            active: item.active
          }
        })
      }
    },
    methods: {
      addCachedView (view) {
        if (view.meta.type === 'menu') {
          this.$store.dispatch('addNavTags', view)
        }
      },
      toggleMenuOpen() {
          this.$store.commit('toggleMenuOpen')
      },
      toPanel() {
          console.info("看板")
          this.$router.push('/Home/home-page/home-page')
      },
      closeTag (index) {
        let tagId = this.tags[index].index
        // 关闭处于激活状态的tag, 此时要切换路由
        if (this.tags[index].active) {
          if (this.tags[index + 1]) {
            this.activeTag(this.tags[index + 1].index)
          } else if (this.tags[index - 1]) {
            this.activeTag(this.tags[index - 1].index)
          } else {
            this.$router.push(`/Home`)
          }
        }

        this.$store.dispatch('removeOneNavTag', {
          index: tagId
        })
        // }
        // log('dispatch removeOneNavTag done')
        // let nextTag = this.navTags.length === 0 ? '/' : this.navTags[this.navTags.length - 1]
        // this.activeTag(nextTag)
      },
      activeTag (tag) {
        this.$router.push(tag)
      }
    },
    mounted () {
      this.addCachedView(this.$route)
    }
  }
</script>

<style>
.v3-tag {
  cursor: pointer;
}
.no-b{
  border: none!important
}
    .panelStyle{
        padding-left: 20px;
        font-size: 14px;
        color: #8d9ab4;
        font-weight: 500;
        position: relative;
        top: -5px;
        cursor: pointer;
    }
</style>
